module.exports = __webpack_public_path__ + "img/contentImgHover8.38bb69c.png";